import { all, fork, put, takeLatest, call, delay } from "redux-saga/effects"

import { NOTIFICATION_PREVIEW, NOTIFICATION_REMOVE } from "constants/ActionTypes"

import { notificationDataSourceUpdate, notificationProcessSuccess } from "appRedux/actions/Notifications"
import { userSignOut } from "appRedux/actions/Auth"
import dayjs from 'dayjs'
import { APIGetRequest, APIPostRequest } from "util/connection"
import { isNull } from 'lodash'
import { API_URL_AUTH, API_HEADERS, API_URL } from "constants/ApiSetting"
import { getItems } from "util/localStorage"

function* GetNotifyFromAPI() {
  try {
    const { access_token } = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL}/v1/pms/system/user/notification`
    API_HEADERS.headers.Authorization = `Bearer ${AccessToken}`

    const response = yield APIGetRequest(url, API_HEADERS)

    if (response.status === 200) {
      // Process and update to action
      return response.data
    } else {
      /* Show error message and signout */
      const { message, data } = response.data
      const processStatus = { status: false, action: "notificationPreview", message: "" }
      yield put(notificationProcessSuccess(processStatus))
      yield delay(100)
      if (response.status === 403) {
        /* if data is not null force signout */
        if (data)
          yield put(userSignOut())
      }
    }
  } catch (error) {
    console.log("Error ", error)
  }
}

function* notificationPreviewProcess({ notify_datas }) {
  try {
    let data_notify = []
    if (isNull(notify_datas)) {
      //get data from API
      data_notify = yield GetNotifyFromAPI()
    } else {
      //get data from socket
      data_notify = notify_datas.last_data
    }

    // Process and update to action
    const notificationDataSource = data_notify.map((o, _k) => {
      const container = {}
      container.key = o.id
      container.notification_id = o.id
      container.notification_title = o.title
      container.notification_message = o.notify_message
      container.ref_id = o.ref_id
      container.ref_type = o.ref_type
      container.create_user = o.create_user
      container.notify_date = dayjs(o.notify_date).format("DD/MM/YYYY HH:mm")
      container.notify_user = o.notify_user
      container.profile_pic = o.profile_user
      return container
    })

    yield put(notificationDataSourceUpdate(notificationDataSource))
    yield delay(100)
  } catch (error) {
  }
}

function* notificationRemoveProcess({ payload }) {
  const notificationID = payload

  try {
    const { access_token } = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL}/v1/pms/system/user/notification/delete`
    API_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
    const API_DATABODY = { id: notificationID }
    const response = yield APIPostRequest(url, API_DATABODY, API_HEADERS)
    if (response.status === 200) {
      const processStatus = { status: true, action: "notification_remove", message: "Remove Success" }
      yield put(notificationProcessSuccess(processStatus))
      yield delay(100)
    } else {
      const { message, data } = response.data
      const processStatus = { status: false, action: "notification_remove", message }
      yield put(notificationProcessSuccess(processStatus))
      yield delay(100)
      if (response.status === 403) {
        /* if data is not null force signout */
        if (data)
          yield put(userSignOut())
      }
    }
  }
  catch (error) {
    const processStatus = { status: false, action: "notification_remove", message: error }
    yield put(notificationProcessSuccess(processStatus))
    yield delay(100)
  }
}

/* Watcher Saga */
export function* notificationPreview() {
  yield takeLatest(NOTIFICATION_PREVIEW, notificationPreviewProcess)
}
export function* notificationRemove() {
  yield takeLatest(NOTIFICATION_REMOVE, notificationRemoveProcess)
}

export default function* rootSaga() {
  yield all([fork(notificationPreview), fork(notificationRemove)])
}
